import { Grid } from "@material-ui/core";
import { AutocompleteInput, number, ReferenceInput, required, SaveButton, TextInput, Toolbar, useDataProvider } from "react-admin";
import { useForm } from "react-final-form";
import { MyDateTimeInput } from "../../MyDateTimeInput";

const AutoCompleteProgramme = () => {
  const form = useForm();
  const dataProvider = useDataProvider();

  const fillProgrammeFields = async (programmeId) => {
    if (!programmeId) {
      return;
    }

    const result = await dataProvider.getProgrammeByProgrammeId(parseInt(programmeId));

    if (result && result.data && result.data.name_tc) {
      form.change("programme_id", programmeId);
      form.change("tc_clean_title", result.data.name_tc);
      form.change("en_clean_title", result.data.name_en);
    }
  };

  return (
    <ReferenceInput
      label="Search Programme Name"
      source="programme_autocomplete"
      reference="programmes-autocomplete"
      onChange={(val) => {
        fillProgrammeFields(val);
      }}
      enableGetChoices={({ name_tc }) => Boolean(name_tc)}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="programme_id" fullWidth />
    </ReferenceInput>
  );
};

export const EpgListingForm = () => {
  return (
    <Grid container spacing={1} fullWidth>
      <Grid item xs={12} sm={12} md={12}>
        <MyDateTimeInput label="Start Time" source="event_datetime" fullWidth validate={required()} disabled />
      </Grid>
      <Grid item sm={12} md={6}>
        <AutoCompleteProgramme />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Content ID" source="programme_id" disabled fullWidth />
      </Grid>
      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in TC *" source="tc_clean_title" disabled fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Caption in EN *" source="en_clean_title" disabled fullWidth />
        </Grid>
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Episode No." source="episode_no" validate={number()} fullWidth />
      </Grid>
    </Grid>
  );
};

export const EpgListingEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const getEpgListingErrorMessage = (error) => {
  const message = error?.body?.message || error?.message || error;
  return Array.isArray(message) ? message.join("\n") : message.toString();
};

export const redirectToEpgEditListing = () => "/epg-edit-listing";
